// ---- components/About.js ----
export function About() {
  return (
    <section id="about" className="px-6 py-16 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-1">
        Production Operations Made Smarter
      </h2>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Ethos Smart Production empowers your manufacturing team with real-time tools to track 
        operator activities, monitor machine performance, conduct quality checks, and manage 
        production workflows — all while seamlessly integrating with your ERP system. With 
        comprehensive dashboards, automated alerts, and data-driven insights, our solution 
        helps your business reduce downtime, improve quality control, and optimize production 
        efficiency. Designed for modern manufacturing, it transforms your factory floor 
        operations from manual processes to intelligent, connected workflows.
      </p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
          <div className="flex items-center">
            <span className="text-green-500 mr-2">✓</span>
            Real-time operator activity tracking
          </div>
          <div className="flex items-center">
            <span className="text-green-500 mr-2">✓</span>
            Automated machine stoppage alerts
          </div>
          <div className="flex items-center">
            <span className="text-green-500 mr-2">✓</span>
            Digital quality control processes
          </div>
          <div className="flex items-center">
            <span className="text-green-500 mr-2">✓</span>
            Seamless ERP system integration
          </div>
        </div>
    </section>
  );
}